import React, { useContext, useEffect, useRef, useState } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import { ChatBox, Footer, Header } from './components'
import GoToTop from './components/GoToTop/GoToTop'
import StatesContext from './context/StatesContext'
import { About, AI, Automation, AutomationEngineer, Blockchain, BlogDetails, Blogs, Career, CodeNews, CodeNewsDetails, CodeTalks, ContactUs, ContentWriter, DataEnginners, Ebook, Ecommerce, Ecover, Education, Fintech, Flutter, Food, Healthcare, Home, MeetUp, Metaverse, MobApp, NFT, Node, Ondemand, Presshq, PresshqDeatils, Pricing, Protfolio, Python, Quality, Reactjs, Robotics, SoftwareDevelopment, SQA, Travel, UI, VacancyDetails, WebApp, WebGl } from './pages'
import { useAlertDetailQuery } from './helpers/alertApi'
import DialogBox from './components/Dialog/Dialog'

import { v4 } from 'uuid';
import { useCreateTrackingClicksMutation } from './helpers/StatisticsApi'

const App = () => {

  const context = useContext(StatesContext)
  const { darkToggle, setDarkToggle } = context

  const [diglogData, setdiglogData] = useState('')

  const [open, setopen] = useState(false)

  const location = useLocation()

  const { data } = useAlertDetailQuery()
  const [trackingCheck, res] = useCreateTrackingClicksMutation()

  const isMounted = useRef(false);

  async function getIPAddress() {

    const response = await fetch('https://api.ipify.org/?format=json');
    const data = await response.json();
    const ipAddress = data.ip;

    const ipApiUrl = `https://ipapi.co/${ipAddress}/json/`;
    const ipApiResponse = await fetch(ipApiUrl);
    const ipApiData = await ipApiResponse.json();

    const userAgent = navigator.userAgent;
    const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
    const deviceType = isMobile ? 'Mobile' : 'Desktop';

    const { country_name: countryName, city, postal, ip, region, country_capital, latitude, longitude } = ipApiData;

    let userId = v4()
    if (localStorage.getItem('userId')) {
      userId = localStorage.getItem('userId')
    }
    const locationObj = { countryName, city, userId, postal, ip, region, country_capital, deviceType, latitude, longitude };

    localStorage.setItem('areaDetails', JSON.stringify(locationObj))
    localStorage.setItem('lastUpdate', Date.now());
    localStorage.setItem('userId', userId)

    trackingCheck({ userId, countryName, city, postal, ip, region, capital: country_capital, deviceType, latitude, longitude })


  }

  useEffect(() => {
    async function fetchData() {

      const lastUpdate = localStorage.getItem('lastUpdate');

      if (!isMounted.current && (!localStorage.getItem('areaDetails') || !lastUpdate || (Date.now() - lastUpdate > 7 * 24 * 60 * 60 * 1000))) {
        await getIPAddress()
      } else if (!isMounted.current) {
        const locationObj = JSON.parse(localStorage.getItem('areaDetails'));
        const { userId, countryName, city, postal, ip, region, country_capital: capital, deviceType, latitude, longitude } = locationObj;
        trackingCheck({ userId, countryName, city, postal, ip, region, capital, deviceType, latitude, longitude })
      }
      isMounted.current = true;
    }
    fetchData();
  }, [])



  useEffect(() => {
    let intervalId;
    if (data && data.alerts.length) {

      data.alerts.forEach(singleAlert => {

        if (singleAlert.show) {
          if (singleAlert.repeat) {
            if (!open) {
              setdiglogData(singleAlert)
              setopen(true);
            }
            intervalId = setInterval(() => {
              if (!open) {
                setopen(true);
                setdiglogData(singleAlert)
              }
            }, singleAlert.time);
          } else {
            if (!open) {
              setopen(true);
              setdiglogData(singleAlert)

            }
          }
        }

      });

    }

    return () => clearInterval(intervalId);
  }, [data]);


  useEffect(() => {
    document.title = open ? '1 new message' : 'CodeZone';
  }, [open]);


  useEffect(() => {

    window.scrollTo(0, 0)

  }, [location])


  return (
    <>
      <div className={`min-h-[100vh] relative max-h-[auto] max-w-[100vw] overflow-hidden transition-all duration-700 ${darkToggle && 'dark'}`}>
        <Header darkToggle={darkToggle} setDarkToggle={setDarkToggle} />
        <DialogBox open={open} setOpen={setopen} data={diglogData} />
        <Routes>
          <Route path='/' element={<Home darkToggle={darkToggle} />} />

          <Route path='/web-app-development-services' element={<WebApp />} />
          <Route path='/mob-app-development-servies' element={<MobApp />} />
          <Route path='/metaverse-development' element={<Metaverse />} />
          <Route path='/NFT-marketplaces-platforms' element={<NFT />} />
          <Route path='/webGL-development' element={<WebGl />} />
          <Route path='/software-development' element={<SoftwareDevelopment />} />
          <Route path='/artificial-intelligence' element={<AI />} />
          <Route path='/ui-ux-design' element={<UI />} />
          <Route path='/robotics' element={<Robotics />} />
          <Route path='/automation-testing' element={<Automation />} />
          <Route path='/quality-assurance' element={<Quality />} />
          <Route path='/blockchain-development' element={<Blockchain />} />
          <Route path='/ebook-cover-making' element={<Ecover />} />
          <Route path='/e-book-writting-both-fiction-and-non-fiction' element={<Ebook />} />
          <Route path='/content-writing' element={<ContentWriter />} />


          <Route path='/E-commerce' element={<Ecommerce />} />
          <Route path='/on-demand-services' element={<Ondemand />} />
          <Route path='/fintech' element={<Fintech />} />
          <Route path='/food-&-delivery' element={<Food />} />
          <Route path='/healthcare' element={<Healthcare />} />
          <Route path='/travel-&-tourism' element={<Travel />} />
          <Route path='/education' element={<Education />} />

          <Route path='/hire-nodejs-developer' element={<Node />} />
          <Route path='/hire-react-developer' element={<Reactjs />} />
          <Route path='/hire-flutter-developer' element={<Flutter />} />
          <Route path='/hire-python-developer' element={<Python />} />
          <Route path='/hire-data-engineers' element={<DataEnginners />} />
          <Route path='/hire-automation-engineers' element={<AutomationEngineer />} />
          <Route path='/hire-sqa-engineers' element={<SQA />} />


          <Route path='/blogs' element={<Blogs />} />
          <Route path='/blog/:slug' element={<BlogDetails />} />
          <Route path='/codeTalks' element={<CodeTalks />} />
          <Route path='/codeNews' element={<CodeNews />} />
          <Route path='/news/:slug' element={<CodeNewsDetails />} />

          <Route path='/about-us' element={<About />} />
          <Route path='/career' element={<Career />} />
          <Route path='/vacancy/:slug' element={<VacancyDetails />} />
          <Route path='/protfolio' element={<Protfolio />} />
          <Route path='/press-hq' element={<Presshq />} />
          <Route path='/press-hq/:slug' element={<PresshqDeatils />} />

          <Route path='/pricing' element={<Pricing />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/meetup' element={<MeetUp />} />

          <Route path='/chat' element={<ChatBox />} />

        </Routes>

        <GoToTop />
        {/* <Chat /> */}
        <Footer />



      </div>
    </>
  )
}

export default App